import { IMSObject, IMSId } from './ims-object';
/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */

export class EmpJobMapping {
  static fromDto(dto: EmpJobMappingCombinedDTO) {
    return new this(
      {
        imsId: dto.jobid,
        secondaryId: undefined,
        objRef: "ims/ServiceJob"
      },
      dto.empids,
      dto.startatflag,
      dto.sortvalue,
      dto.comment,
      dto.plannedfromts,
      dto.worktypeid,
      dto.carid,
      {
        imsId: dto.orderitemid,
        secondaryId: undefined,
        objRef: 'ims/OrderItem'
      },
      dto.borrowedEmps,
      dto.lentEmps,
      dto.leader,
    );
  }
  constructor(
    public readonly jobid: IMSId,
    public readonly empids: number[],
    public readonly startatflag: string,
    public readonly sortvalue: string,
    public readonly comment: string,
    public readonly plannedfromts: number,
    public readonly worktypeid: number = undefined,
    public readonly carid: number = undefined,
    public readonly orderitemid: IMSId = undefined,
    public readonly borrowedEmps: number[] = [],
    public readonly lentEmps: number[] = [],
    public readonly leader: number,
  ) {}
}

export interface EmpJobMappingCombinedDTO {
  jobid: number;
  empids: number[];
  startatflag: string;
  sortvalue: string;
  comment: string;
  plannedfromts: number;
  worktypeid: number;
  carid: number;
  orderitemid: number;
  lentEmps: number[];
  borrowedEmps: number[];
  leader: number;
}

export interface EmpJobMappingDTO {
  jobid: number;
  empid: number;
  startatflag: string;
  sortvalue: string;
  comment: string;
  plannedfromts: number;
  worktypeid: number;
  carid: number;
  orderitemid: number;
  islent: boolean;
  isborrowed: boolean;
  leader: number;
}
